<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon
                 class="mr-2"
                 :color="iconColor"
                 v-on="{ ...onTooltip, ...on }"
                 @click.stop.prevent=""
          >
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
        </template>
        <span>Filtrar por</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row dense>
          <v-col cols="12">
            <px-autocomplete-comprador
              required
              dense
              class="rounded-tag-small"
              v-model="localEmpresa"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-user-comprador-multiple
              outlined
              dense
              label="Solicitantes"
              autocomplete="off"
              class="rounded-tag-small"
              :roles="[]"
              v-model="localResponsavel"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-produto-multiple v-model="localProduto"
                                     class="rounded-tag-small"
                                     show-details
                                     dense
                                     base-path="/produtos/page"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-centro-custo-multiple
              class="rounded-tag-small"
              dense
              v-model="localCentroCusto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-projeto-multiple
              dense
              class="rounded-tag-small"
              v-model="localProjeto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-grupo-multiple
              dense
              class="rounded-tag-small"
              v-model="localGrupo"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-spacer/>
        <v-btn text class="normal-btn-text" @click="clearFilters">
          Limpar filtros
        </v-btn>
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="emitChange">
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      menuOpened: false,
      localEmpresa: null,
      localCentroCusto: [],
      localProduto: [],
      localProjeto: [],
      localResponsavel: [],
      localGrupo: [],
    };
  },
  computed: {
    ...mapGetters('requisicaoGeracao', ['hasCustomFilters']),
    iconColor() {
      return this.hasCustomFilters ? 'primary' : '';
    },
    centrosCustos: {
      get() {
        return this.$store.getters['requisicaoGeracao/centrosCustos'];
      },
      set(centrosCustos) {
        this.$store.dispatch('requisicaoGeracao/centrosCustos', centrosCustos);
      },
    },
    solicitantes: {
      get() {
        return this.$store.getters['requisicaoGeracao/solicitantes'];
      },
      set(solicitantes) {
        this.$store.dispatch('requisicaoGeracao/solicitantes', solicitantes);
      },
    },
    empresa: {
      get() {
        return this.$store.getters['requisicaoGeracao/empresa'];
      },
      set(empresa) {
        this.$store.dispatch('requisicaoGeracao/empresa', empresa);
      },
    },
    produto: {
      get() {
        return this.$store.getters['requisicaoGeracao/produto'];
      },
      set(produto) {
        this.$store.dispatch('requisicaoGeracao/produto', produto);
      },
    },
    projeto: {
      get() {
        return this.$store.getters['requisicaoGeracao/projeto'];
      },
      set(projeto) {
        this.$store.dispatch('requisicaoGeracao/projeto', projeto);
      },
    },
    grupo: {
      get() {
        return this.$store.getters['requisicaoGeracao/grupo'];
      },
      set(grupo) {
        this.$store.dispatch('requisicaoGeracao/grupo', grupo);
      },
    },
  },
  methods: {
    emitChange() {
      this.empresa = this.localEmpresa;
      this.centrosCustos = this.localCentroCusto;
      this.produto = this.localProduto;
      this.projeto = this.localProjeto;
      this.solicitantes = this.localResponsavel;
      this.grupo = this.localGrupo;
      this.$emit('change');
      this.close();
    },
    clearFilters() {
      this.localEmpresa = null;
      this.localCentroCusto = null;
      this.localProduto = null;
      this.localProjeto = null;
      this.localResponsavel = null;
      this.localGrupo = null;
      this.emitChange();
    },
    close() {
      this.menuOpened = false;
    },
  },
  created() {
    this.localEmpresa = this.empresa || null;
    this.localCentroCusto = this.centrosCustos || [];
    this.localProduto = this.produto || [];
    this.localProjeto = this.projeto || [];
    this.localResponsavel = this.solicitantes || [];
    this.localGrupo = this.grupo || [];
  },
};
</script>
